<!-- 基地 右侧展示的详情 -->
<style lang="stylus" scoped>
.details
  position absolute
  left 550px
  top 390px
  width 500px
  color #fff
  z-index 11
  .img1
    position absolute
    left 30px
    top 30px
  .img2
    position absolute
    left 100px
    top 100px
  .img3
    position absolute
    left 200px
    top 200px
  .img4
    position absolute
    left 300px
    top 300px
</style>

<template>
  <div class="details">
    <img class="img1" @click="change(1)" src="static/img/base/weather-icon.png" alt="">
    <img class="img2" @click="change(0)" src="static/img/base/monitor-icon.png" alt="">
    <img class="img3" @click="change(3)" src="static/img/base/icon.png" alt="">
    <img class="img4" @click="change(2)" src="static/img/base/icon0.png" alt="">
  </div>
</template>

<script>
export default {
  props: {
    activeItem: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      show: false
    }
  },
  components: {},
  mounted() {

  },
  methods: {
    // 点击切换索引
    change(newIndex) {
      this.$emit('indexChange', newIndex)
    }
  }
}

</script>



// WEBPACK FOOTER //
// index.vue?a1f4fcd8